module.exports = __webpack_public_path__ + "img/onetime-passcode-iconb.50e27d33.svg";